import React from 'react'
import { withRouter } from 'react-router-dom';
import { Message, Dimmer, Loader, Button, Grid, Divider, Segment } from 'semantic-ui-react';
import InpatientNavigationView from "../../../component/sysadmin/inpatient/inpatient_navigation_view";
import InpatientView from "../../../component/sysadmin/inpatient/inpatient_view";
import InpatientViewImbursement from "../../../component/sysadmin/inpatient/inpatient_view_imbursement";
import InpatientViewSystemData from "../../../component/sysadmin/inpatient/inpatient_view_system_data";
import { Route, Switch } from 'react-router-dom';

class InpatientViewPage extends React.Component {

    render() {

        return (
            <Grid>
                <Grid.Column width={4}>
                    <InpatientNavigationView />
                </Grid.Column>

                <Grid.Column width={12}>
                    <Switch>
                        <Route path="/systemadmin/userinpatient/view/imbursement" component={() => <InpatientViewImbursement />} />
                        <Route path="/systemadmin/userinpatient/view/systemdata" component={() => <InpatientViewSystemData />} />
                        <Route path="/systemadmin/userinpatient/view" component={() => <InpatientView />} />
                    </Switch>
                </Grid.Column>

            </Grid>
        )
    }

}

export default withRouter(InpatientViewPage);